import { ACTION_TYPES as types } from './action-types';
export const setCarrier = ( selectedCarrierId ) => {
	return {
		type: types.SET_CARRIER,
		selectedCarrierId,
	};
};
export const setDate = ( date ) => {
	return {
		type: types.SET_DATE,
		date,
	};
};

export const setTimeSlot = ( timeSlot ) => {
	return {
		type: types.SET_TIMESLOT,
		timeSlot,
	};
};
export const setProcessingMethod = ( processingMethodID ) => {
	return {
		type: types.SET_PROCESSING_METHOD,
		processingMethodID,
	};
};
export const setCarriers = ( allCarriers ) => {
	return {
		type: types.SET_CARRIERS,
		allCarriers,
	};
};

export const setDates = ( allDates ) => {
	return {
		type: types.SET_DATES,
		allDates,
	};
};
export const setTimeSlots = ( allSlots ) => {
	return {
		type: types.SET_TIMESLOTS,
		allSlots,
	};
};
export const setInitialized = ( initialized ) => {
	return {
		type: types.INITIALIZED,
		initialized,
	};
};
export const setUpdatingDates = ( isUpdate ) => {
	return {
		type: types.UPDATING_DATES,
		isUpdate,
	};
};
export const fetchFromAPI = ( path ) => {
	return {
		type: 'FETCH_FROM_API',
		path,
	};
};
